import { Box } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import HomeIcon from "@mui/icons-material/Home";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";

export const NavItemIcon = ({ icon, size = 22 }: { icon: string; size?: number }) =>
  icon === "home" ? (
    <HomeIcon sx={{ fontSize: size }} />
  ) : icon === "archive" ? (
    <ArchiveOutlinedIcon sx={{ fontSize: size }} />
  ) : icon === "settings" ? (
    <SettingsIcon sx={{ fontSize: size }} />
  ) : icon === "chess-board" ? (
    <Box component="svg" aria-hidden viewBox="0 0 24 24" sx={{ width: size, height: size, display: "block" }}>
      <path d="M2 2h20v20H2z" fill="none" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M2 2h5v5H2zM12 2h5v5h-5zM7 7h5v5H7zM17 7h5v5h-5zM2 12h5v5H2zM12 12h5v5h-5zM7 17h5v5H7zM17 17h5v5h-5z"
        fill="currentColor"
      />
    </Box>
  ) : icon === "board-trend" ? (
    <Box component="svg" aria-hidden viewBox="0 0 24 24" sx={{ width: size, height: size, display: "block" }}>
      <path
        d="M2.5 2.5h19v19h-19zM9 2.5v19M15 2.5v19M2.5 9h19M2.5 15h19"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="m4.5 17 4-4 3 2 7-8"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="square"
        strokeLinejoin="miter"
      />
    </Box>
  ) : icon === "focus" ? (
    <TrackChangesIcon sx={{ fontSize: size }} />
  ) : icon === "help-book" ? (
    <MenuBookIcon sx={{ fontSize: size }} />
  ) : (
    <Box component="span" aria-hidden sx={{ fontSize: size, lineHeight: 1, fontWeight: 700 }}>
      {icon}
    </Box>
  );
